// Need to always update here to make it correct
export const GRADIENT_COLORS = {
  'bohemian-silver-metallic': '#9C9C9C',
  'bavarian-black-mica': '#383838',
  'dolomite-pearl-white': '#FAFAFA',
  'siberian-white': '#E7EDF6',
  'namibu-orange-mica': '#AE261E',
  'eiger-gray-opaque': '#98A2B0',
  'elbrus-gray-opaque': '#737471',
  'etna-red-mica': '#8C2C3A',
  'iceberg-silver-mica': '#616265',
  'inishmore-gray-opaque': '#9CA3A1',
} as const;

type GradientColorKeyType = keyof typeof GRADIENT_COLORS;

export interface LcvColor {
  title: string;
  uid: string;
  active: boolean;
  name: GradientColorKeyType;
  name_th: string;
  name_en: string;
}
